import { InfoIcon } from 'lucide-react';

import { cn, TableHead } from '@crossnokaye/ux-common';

import {
  Tooltip,
  TooltipArrow,
  TooltipContent,
  TooltipPortal,
  TooltipTrigger,
} from '@/ux-common/components/tooltip/tooltip';

import {
  ENERGY_AI_COLUMN_CLASS,
  ENERGY_AI_HEADER_INFO_LABEL,
  ENERGY_AI_HEADER_TOOLTIP_ACTIVE,
  ENERGY_AI_HEADER_TOOLTIP_INACTIVE,
} from '../compressor-energy-ai.constants';

interface CompressorEnergyAIStageHeaderProps {
  isEnergyAIActive: boolean;
}

export const CompressorEnergyAIStageHeader = ({
  isEnergyAIActive,
}: CompressorEnergyAIStageHeaderProps) => {
  return (
    <TableHead
      className={cn(
        'relative border-b-1 border-black',
        isEnergyAIActive
          ? 'bg-ckds-base-white text-ckds-neutral-950'
          : 'bg-ckds-neutral-900 text-ckds-text-fg-tier3',
        ENERGY_AI_COLUMN_CLASS
      )}
      data-component="CompressorEnergyAIStageHeader"
    >
      <div className="flex h-full items-center justify-center gap-1 whitespace-nowrap px-1 text-xs font-bold">
        <span>ENERGY AI</span>
        <Tooltip>
          {/*
            The trigger must be a button: Radix does not make an `asChild` target
            focusable, so hanging the tooltip off the bare icon left the only
            explanation of this column reachable by pointer alone.
          */}
          <TooltipTrigger asChild>
            <button
              aria-label={ENERGY_AI_HEADER_INFO_LABEL}
              className="inline-flex shrink-0 items-center outline-none ring-offset-background focus-visible:ring-2 focus-visible:ring-ring"
              type="button"
            >
              <InfoIcon aria-hidden="true" className="h-3 w-3" />
            </button>
          </TooltipTrigger>
          <TooltipPortal>
            <TooltipContent align="center" side="bottom">
              <span>
                {isEnergyAIActive
                  ? ENERGY_AI_HEADER_TOOLTIP_ACTIVE
                  : ENERGY_AI_HEADER_TOOLTIP_INACTIVE}
              </span>
              <TooltipArrow />
            </TooltipContent>
          </TooltipPortal>
        </Tooltip>
      </div>
    </TableHead>
  );
};
